
export default {
	name: 'PricePopover',
	props: {
		goodsInfo: {
			type: Object,
			default: () => ({})
		},
		action: {
			type: String,
			default: ''
		},
		currentPrice: {
			type: [Number, String],
			default: ''
		}
	},
	data() {
		return {
			loading: false,
			scriptList: []
		}
	},
	created() {
		this.fetchScriptConfig()
	},
	methods: {
		async fetchScriptConfig() {
			try {
				this.loading = true

				// 调用接口获取脚本配置
				const res = await this.$api.bargainImBuyerScriptConfigAPI()

				if (res && res.success) {
					this.scriptList = res.data || []
				} else {
					console.error('获取砍价脚本配置失败:', res?.info || '未知错误')
				}
			} catch (error) {
				console.error('获取砍价脚本配置异常:', error)
			} finally {
				this.loading = false
			}
		},
		handleSelect(item) {
			// 选择一个脚本发送
			this.$emit('submit', item.scriptContent)
			this.handleClose()
		},
		handleClose() {
			// 关闭弹窗
			this.$parent.pricePopoverVisible = false
		}
	}
}
